var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('canvas',{attrs:{"id":`canvas-radial${this.attributes.model}`},on:{"mousedown":_vm.radialClick}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }